(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('.sticky-atc-bar');
    if (!bar) return;

    var stickyEl = bar.querySelector('sticky-atc-bar');
    var sectionId = stickyEl ? stickyEl.dataset.section : null;
    var form = bar.querySelector('form[is="product-form"]');
    var submitBtn = bar.querySelector('.product-form__submit');
    var variantSelect = bar.querySelector('.sticky-atc-bar__variant-select');

    if (!form || !submitBtn || !sectionId || !variantSelect) return;

    var testWrapper = document.querySelector('.fc-qatc-test');
    var popup = document.getElementById('FcQatcPopup-' + sectionId);
    if (!testWrapper || !popup) return;

    var popupSheet = popup.querySelector('.fc-qatc-popup__sheet');
    var popupSubmitBtn = popup.querySelector('[data-fc-qatc-add]');
    var popupSubmitText = popupSubmitBtn ? popupSubmitBtn.querySelector('span') : null;

    var variantsJson = bar.querySelector('script[type="application/json"]');
    if (!variantsJson) return;
    var variants = JSON.parse(variantsJson.textContent);

    var productId = stickyEl.dataset.productId;
    var mainProductInfo = document.querySelector(
      'product-info[data-product-id="' + productId + '"]'
    );

    var hasRequiredFields = false;
    if (mainProductInfo) {
      hasRequiredFields =
        mainProductInfo.querySelectorAll('[data-custom-property]').length > 0;
    }

    var selectedOptions = [];
    var currentVariant = null;
    var isPopupOpen = false;
    var isUpdating = false;
    var testActive = null;

    syncFromSelect();

    function syncFromSelect() {
      var id = Number(variantSelect.value);
      currentVariant = variants.find(function (v) {
        return v.id === id;
      });
      if (currentVariant) {
        selectedOptions = [
          currentVariant.option1,
          currentVariant.option2,
          currentVariant.option3,
        ].filter(Boolean);
      }
    }

    function isTestActive() {
      if (testActive === null) {
        testActive = getComputedStyle(testWrapper).display !== 'none';
      }
      return testActive;
    }

    /* ---- Intercept V1's ATC button ---- */

    submitBtn.addEventListener(
      'click',
      function (e) {
        if (!isTestActive() || hasRequiredFields) return;
        e.preventDefault();
        e.stopPropagation();
        openPopup();
      },
      true
    );

    /* ---- Popup open / close ---- */

    function openPopup() {
      syncFromSelect();
      updateSelectedStates();
      updateAvailability();
      updatePopupButton();

      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('fc-qatc-popup-open');

      requestAnimationFrame(function () {
        popup.classList.add('fc-qatc-popup--open');
      });

      isPopupOpen = true;

      var firstSelected = popupSheet.querySelector('[aria-checked="true"]');
      if (firstSelected) firstSelected.focus();
    }

    function closePopup() {
      popup.classList.remove('fc-qatc-popup--open');
      document.body.classList.remove('fc-qatc-popup-open');
      isPopupOpen = false;

      setTimeout(function () {
        popup.hidden = true;
        popup.setAttribute('aria-hidden', 'true');
        submitBtn.focus();
      }, 300);
    }

    /* ---- Popup event listeners ---- */

    var overlay = popup.querySelector('.fc-qatc-popup__overlay');
    if (overlay) overlay.addEventListener('click', closePopup);

    var handleArea = popup.querySelector('.fc-qatc-popup__handle-area');
    if (handleArea) handleArea.addEventListener('click', closePopup);

    var closeBtn = popup.querySelector('[data-fc-qatc-close]');
    if (closeBtn) closeBtn.addEventListener('click', closePopup);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isPopupOpen) closePopup();
    });

    /* ---- Swipe down to close ---- */

    var touchStartY = 0;
    var isDragging = false;

    popupSheet.addEventListener(
      'touchstart',
      function (e) {
        if (popupSheet.scrollTop > 0) return;
        touchStartY = e.touches[0].clientY;
        isDragging = true;
        popupSheet.style.transition = 'none';
      },
      { passive: true }
    );

    popupSheet.addEventListener(
      'touchmove',
      function (e) {
        if (!isDragging) return;
        var deltaY = e.touches[0].clientY - touchStartY;
        if (deltaY < 0) deltaY = 0;
        popupSheet.style.transform = 'translateY(' + deltaY + 'px)';
      },
      { passive: true }
    );

    popupSheet.addEventListener('touchend', function (e) {
      if (!isDragging) return;
      isDragging = false;
      var endY = e.changedTouches[0] ? e.changedTouches[0].clientY : touchStartY;
      var deltaY = endY - touchStartY;
      popupSheet.style.transition = '';

      if (deltaY > 80) {
        popupSheet.style.transform = 'translateY(100%)';
        closePopup();
        setTimeout(function () {
          popupSheet.style.transform = '';
        }, 350);
      } else {
        popupSheet.style.transform = '';
      }
    });

    popup.querySelectorAll('[data-option-value]').forEach(function (btn) {
      btn.addEventListener('click', handleOptionSelect);
    });

    if (popupSubmitBtn) {
      popupSubmitBtn.addEventListener('click', handlePopupAddToCart);
    }

    /* ---- Option selection ---- */

    function handleOptionSelect(e) {
      var btn = e.currentTarget;
      if (
        btn.classList.contains('fc-qatc-popup__pill--disabled') ||
        btn.classList.contains('fc-qatc-popup__swatch--disabled')
      )
        return;

      var optionIndex = parseInt(btn.dataset.optionIndex);
      selectedOptions[optionIndex] = btn.dataset.optionValue;

      updateSelectedStates();
      updateAvailability();

      currentVariant = findMatchingVariant();

      if (currentVariant) {
        isUpdating = true;
        variantSelect.value = currentVariant.id;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        setTimeout(function () {
          isUpdating = false;
        }, 100);
      }

      updatePopupButton();
    }

    function findMatchingVariant() {
      return variants.find(function (variant) {
        return selectedOptions.every(function (value, index) {
          return variant['option' + (index + 1)] === value;
        });
      });
    }

    function updateSelectedStates() {
      popup.querySelectorAll('[data-option-value]').forEach(function (btn) {
        var idx = parseInt(btn.dataset.optionIndex);
        var val = btn.dataset.optionValue;
        var isSelected = selectedOptions[idx] === val;

        if (btn.classList.contains('fc-qatc-popup__pill')) {
          btn.classList.toggle('fc-qatc-popup__pill--selected', isSelected);
        } else if (btn.classList.contains('fc-qatc-popup__swatch')) {
          btn.classList.toggle('fc-qatc-popup__swatch--selected', isSelected);
        }
        btn.setAttribute('aria-checked', isSelected.toString());
      });
    }

    function updateAvailability() {
      popup.querySelectorAll('[data-option-value]').forEach(function (btn) {
        var optionIndex = parseInt(btn.dataset.optionIndex);
        var optionValue = btn.dataset.optionValue;

        var isAvailable = variants.some(function (variant) {
          if (!variant.available) return false;
          if (variant['option' + (optionIndex + 1)] !== optionValue) return false;
          for (var i = 0; i < selectedOptions.length; i++) {
            if (i === optionIndex) continue;
            if (
              selectedOptions[i] &&
              variant['option' + (i + 1)] !== selectedOptions[i]
            )
              return false;
          }
          return true;
        });

        if (btn.classList.contains('fc-qatc-popup__pill')) {
          btn.classList.toggle('fc-qatc-popup__pill--disabled', !isAvailable);
        } else if (btn.classList.contains('fc-qatc-popup__swatch')) {
          btn.classList.toggle('fc-qatc-popup__swatch--disabled', !isAvailable);
        }
      });
    }

    function updatePopupButton() {
      var available = currentVariant ? currentVariant.available : false;

      if (popupSubmitBtn) {
        popupSubmitBtn.disabled = !available;
        if (popupSubmitText) {
          popupSubmitText.textContent = available
            ? FoxTheme.variantStrings.addToCart
            : FoxTheme.variantStrings.soldOut;
        }
      }
    }

    /* ---- Add to cart from popup ---- */

    function handlePopupAddToCart() {
      if (!currentVariant || !currentVariant.available) return;

      variantSelect.value = currentVariant.id;
      closePopup();
      setTimeout(function () {
        form.requestSubmit();
      }, 100);
    }

    /* ---- Sync: main PDP → popup ---- */

    if (
      typeof FoxTheme !== 'undefined' &&
      FoxTheme.pubsub &&
      mainProductInfo
    ) {
      FoxTheme.pubsub.subscribe(
        FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
        function (event) {
          var isMainProduct =
            event.data.sectionId === mainProductInfo.dataset.section;
          if (!isMainProduct || isUpdating) return;

          var variant = event.data.variant;
          if (!variant) return;

          currentVariant = variant;
          selectedOptions = [
            variant.option1,
            variant.option2,
            variant.option3,
          ].filter(Boolean);

          updateSelectedStates();
          updateAvailability();
          updatePopupButton();
        }
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
